module.exports = __webpack_public_path__ + "static/media/servicios_autotransporte.89608c76.jpg";